import { Service } from '~publish/legacy/constants/services/ServiceDefinitions'
import type { Profile, Subprofile } from '~publish/legacy/profile-sidebar/types'

interface Schedule {
  days: string[]
  times: string[]
}

export interface ApiProfileResponse {
  id: string
  avatar_https: string
  can_post_comment: boolean
  service: Service
  service_username: string
  counts: { pending: number; sent: number }
  timezone: string
  timezone_city: string
  schedules: Schedule[]
  paused_schedules: Schedule[]
  service_type: string
  service_id: string
  should_post_direct: boolean
  formatted_username: string
  subprofiles?: Subprofile[]
  disabled: boolean
  default: boolean
  paused: boolean
  is_instagram_business: boolean
  is_pinterest_business: boolean
  preferences?: {
    utm_tracking?: string
    shortener?: { name: string }
  }
  has_push_notifications: boolean
  oauth_broken: boolean
  location?: string
  can_associate_location: boolean
  organization_id: string
  business?: boolean
  api_version: string | null
  permissions: string[]
  display_name: string | null
  server_url: string | null
  locationData?: { location?: string }
  default_to_reminders?: boolean
  isTwitterPremium?: boolean
  show_trending_topic_suggestions?: boolean
}

const isInstagramAnalyticsSupported = (profile: ApiProfileResponse): boolean =>
  profile.service === Service.Instagram && profile.is_instagram_business

export default (profile: ApiProfileResponse): Profile => ({
  id: profile.id,
  avatarUrl: profile.avatar_https,
  avatar_https: profile.avatar_https,
  canPostComment: profile.can_post_comment,
  type: profile.service,
  handle: profile.service_username,
  pendingCount: profile.counts.pending,
  sentCount: profile.counts.sent,
  timezone: profile.timezone,
  timezone_city: profile.timezone_city,
  schedules: profile.schedules,
  pausedSchedules: profile.paused_schedules,
  service: profile.service,
  service_type: profile.service_type,
  serviceUsername: profile.service_username,
  serviceId: profile.service_id,
  service_username: profile.service_username,
  should_post_direct: profile.should_post_direct,
  formatted_username: profile.formatted_username,
  subprofiles: profile.subprofiles,
  disabled: profile.disabled,
  default: profile.default,
  paused: profile.paused,
  open: false,
  isInstagramBusiness: profile.is_instagram_business,
  isPinterestBusiness: profile.is_pinterest_business,
  googleAnalyticsEnabled: profile.preferences?.utm_tracking,
  hasPushNotifications: profile.has_push_notifications,
  isDisconnected: profile.oauth_broken,
  location: profile.location,
  canAssociateLocation: profile.can_associate_location,

  // Remove when publish stops importing Analyze components
  organizationId: profile.organization_id,

  username: profile.service_username,

  shorteningDomain: profile.preferences?.shortener?.name || 'buff.ly',

  isAnalyticsSupported:
    !!profile.business &&
    (profile.service === Service.Twitter ||
      profile.service === Service.Facebook ||
      isInstagramAnalyticsSupported(profile)),

  api_version: profile?.api_version,
  permissions: profile.permissions,
  displayName: profile.display_name,
  serverUrl: profile.server_url,
  locationData: profile.locationData?.location,
  defaultToReminders: profile?.default_to_reminders ?? false,
  isTwitterPremium: profile?.isTwitterPremium ?? false,
  showTrendingTopicSuggestions:
    profile?.show_trending_topic_suggestions ?? true,
})
